import { PLATFORM } from '../../constants/platforms';
import { withPlatForm } from '../../utils/matcher/matcher';
import dynamic from 'next/dynamic';
const DesktopHorizontalLinksWidget = dynamic(() => import('./DesktopHorizontalLinksWidget'));
const MobileHorizontalLinksWidget = dynamic(() => import('./MobileHorizontalLinksWidget'));

const HorizontalLinksWidget = (props: any) => {
	return (
		<>
			{withPlatForm([
				{
					platform: PLATFORM.D_WEB,
					component: <DesktopHorizontalLinksWidget {...props} />,
				},
				{
					platform: [PLATFORM.M_WEB, PLATFORM.H5],
					component: <MobileHorizontalLinksWidget {...props} />,
				},
			])}
		</>
	);
};

export default HorizontalLinksWidget;
